import { Radio, RadioTower } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useWebSocketContext } from './WebSocketProvider'
import { cn } from '@/lib/utils'

export function WebSocketStatus() {
  const { t } = useTranslation('notifications')
  const { isConnected } = useWebSocketContext()

  return (
    <div
      className={cn(
        'flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium transition-colors',
        isConnected
          ? 'bg-green-500/10 text-green-600 dark:text-green-400'
          : 'bg-red-500/10 text-red-500 dark:text-red-400'
      )}
      title={isConnected ? t('websocket.connected') : t('websocket.disconnected')}
    >
      {isConnected ? (
        <>
          <span className="relative flex h-2 w-2">
            <span className="animate-pulse inline-flex h-2 w-2 rounded-full bg-green-500 opacity-75" />
          </span>
          <Radio className="h-3 w-3" />
          <span className="hidden sm:inline">{t('websocket.live')}</span>
        </>
      ) : (
        <>
          <RadioTower className="h-3 w-3" />
          <span className="hidden sm:inline">{t('websocket.off')}</span>
        </>
      )}
    </div>
  )
}
